import { defineComponent } from 'vue';
import MessageBoxWithIcon from '@common/layout/messageBox/MessageBoxWithIcon.vue';
import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
import { translator } from '~/zf/frontend/common/mixins';
import AffectedComponent from '../atoms/AffectedComponent.vue';
import PlainDuration from '../atoms/PlainDuration.vue';
export default defineComponent({
    name: 'ReactivateBody',
    compatConfig: {
        MODE: 3,
    },
    components: { PlainDuration, AffectedComponent, MessageBoxWithIcon },
    mixins: [translator],
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            BootstrapVariant,
        };
    },
});
